import { FormValues } from "../../../components/Store/reducers/formReducer/types"

export const formatters = (data: FormValues) => {
    const birthday = new Date(data.birthday)
    const resumesAttributes = data.userResumesAttributes[0]
    const isCurrentlyEmployed = data.situation === "tenure"
    return {
        first_name: data.firstName,
        last_name: data.lastName,
        first_name_kana: data.firstNameKana,
        last_name_kana: data.lastNameKana,
        birthday_year: birthday.getFullYear(),
        birthday_month: birthday.getMonth() + 1,
        sex: data.sex,
        tel: data.tel,
        line_id: data.lineId,
        situation: data.situation,
        prefecture_id: data.prefecture,
        city_id: data.city,
        experience_years: data.experienceYears,
        email: data.email,
        password: data.password,
        user_resumes_attributes: {
            0: {
                company_name: resumesAttributes.companyName,
                employment_id: resumesAttributes.employmentId,
                genre_id: resumesAttributes.genreId,
                occupation_ids: [resumesAttributes.occupationIds],
                job_description: resumesAttributes.detailedJobDetails,
                work_start_date_year: resumesAttributes.workStartYear,
                work_start_date_month: resumesAttributes.workStartMonth,
                work_end_date_year: isCurrentlyEmployed
                    ? null
                    : resumesAttributes.workEndDateYear,
                work_end_date_month: isCurrentlyEmployed
                    ? null
                    : resumesAttributes.workEndDateMonth,
                user_occupation_resumes_attributes: [
                    {
                        occupation_id: resumesAttributes.occupationIds,
                    },
                ],
            },
        },
        mail_magazine: 1,
        agent_service: 1,
    }
}
